import { atsApiQuery } from '../';

export const schedulingApi = atsApiQuery.injectEndpoints({
  endpoints: (builder) => {
    return {
      fetchInterviewerEvent: builder.mutation({
        transformResponse: (response) => response.data,
        query: ({ params }) => {
          return {
            method: 'get',
            url: `calendar_events`,
            params,
          };
        },
      }),
      createInterview: builder.mutation({
        transformResponse: (response) => response.data,
        query: (payload) => {
          return {
            method: 'post',
            url: `ats_interviews`,
            data: payload,
          };
        },
      }),
      updateInterview: builder.mutation({
        transformResponse: (response) => response.data,
        query: ({ interviewDetails, interviewId }) => {
          return {
            method: 'put',
            url: `ats_interviews/${interviewId}`,
            data: interviewDetails,
          };
        },
      }),
      scheduleInterview: builder.mutation({
        transformResponse: (response) => response.data,
        query: (payload) => {
          return {
            method: 'post',
            url: `ats_schedules`,
            data: payload,
          };
        },
      }),
      updateScheduleInterview: builder.mutation({
        transformResponse: (response) => response.data,
        query: ({ interviewDetails, scheduleId }) => {
          return {
            method: 'put',
            url: `ats_schedules/${scheduleId}`,
            data: interviewDetails,
          };
        },
      }),
      getMeetingDetails: builder.query({
        transformResponse: (response) => response.data,
        query: ({ interviewId }) => {
          return {
            method: 'get',
            url: `ats_interviews/${interviewId}/meeting_details`,
          };
        },
      }),
      deleteInterview: builder.mutation({
        transformResponse: (response) => response.data,
        query: ({ interviewId }) => {
          return {
            method: 'delete',
            url: `ats_interviews/${interviewId}`,
          };
        },
      }),
      deleteSchedule: builder.mutation({
        transformResponse: (response) => response.data,
        query: ({ scheduleId }) => {
          return {
            method: 'delete',
            url: `ats_schedules/${scheduleId}`,
          };
        },
      }),
      fetchSuggestedInterviewerDetails: builder.mutation({
        transformResponse: (response) => response.data,
        query: (payload) => {
          const { id } = payload;
          return {
            method: 'get',
            url: `ats_interviews/suggested_interviewer?fetch_uuid=${id}`,
          };
        },
      }),
      fetchScheduleSlots: builder.mutation({
        transformResponse: (response) => response.data,
        query: (payload) => {
          return {
            method: 'post',
            url: `ats_schedules/slots/trigger_fetch`,
            data: payload,
          };
        },
      }),
      fetchScheduleSlotsData: builder.mutation({
        transformResponse: (response) => response.data,
        query: (payload) => {
          return {
            method: 'post',
            url: `ats_schedules/slots/trigger_fetch`,
            data: payload,
          };
        },
      }),
      fetchLocation: builder.query({
        transformResponse: (response) => response?.data?.locations,
        query: () => {
          return {
            method: 'get',
            url: `ats_interviews/locations`,
          };
        },
      }),
      fetchZoomLimit: builder.mutation({
        transformResponse: (response) => response?.data,
        query: () => {
          return {
            method: 'get',
            url: `ats_interviews/zoom_availability`,
          };
        },
      }),
      fetchInterviewersSchedule: builder.mutation({
        transformResponse: (response) => response?.data,
        query: (payload) => {
          const { weekStart, timezone, interviewerIds } = payload;
          const params = {
            week_start_date: weekStart,
            time_zone: timezone,
            interviewer_ids: interviewerIds,
          };
          return {
            method: 'get',
            url: `/ats_interviews/interviewers_schedule`,
            params,
          };
        },
      }),
      sendInterviewReminder: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload }) => {
          return {
            method: 'post',
            url: `/interview_reminders/trigger_rsvp_reminder`,
            data: payload,
          };
        },
      }),
      sendScheduleReminder: builder.mutation({
        transformResponse: (response) => response?.data,
        query: ({ payload }) => {
          return {
            method: 'post',
            url: `/schedule_reminders/remind_candidate`,
            data: payload,
          };
        },
      }),
      // Dev/staging only (gated by the t_demo_interview_harness flag + a prod guard on the server): kicks off
      // the simulated-interview harness for a live sales demo.
      runDemoHarness: builder.mutation({
        query: ({ interviewId, durationMin }) => {
          return {
            method: 'post',
            url: `ats_interviews/${interviewId}/demo_harness`,
            data: { duration_min: durationMin },
          };
        },
      }),
    };
  },
  overrideExisting: true,
});

export const {
  useFetchInterviewerEventMutation,
  useCreateInterviewMutation,
  useUpdateInterviewMutation,
  useScheduleInterviewMutation,
  useUpdateScheduleInterviewMutation,
  useGetMeetingDetailsQuery,
  useDeleteInterviewMutation,
  useFetchSuggestedInterviewerDetailsMutation,
  useFetchLocationQuery,
  useFetchZoomLimitMutation,
  useFetchInterviewersScheduleMutation,
  useSendInterviewReminderMutation,
  useSendScheduleReminderMutation,
  useDeleteScheduleMutation,
  useFetchScheduleSlotsMutation,
  useFetchScheduleSlotsDataMutation,
  useRunDemoHarnessMutation,
} = schedulingApi;
